// extracted by mini-css-extract-plugin
export default {"footer_main":"footer_footer_main__zuGUn","footer_title":"footer_footer_title__TYJg3"};